import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import { translateResourceString } from '../../../util/translationUtility';
import { makeCatalystFetchPostInit } from "../../../util/fetchUtility";

class TitlesIncludedInLicense extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titles: [],
            isOpen: false,
            deleteFromLicenseUrl: ""
          };
         this.toggleModal = this.toggleModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal = (isOpen) => {
        this.setState({ isOpen: isOpen });
    }

    removeTitleFromLicense = (skuToRemove) => {
        if (window.confirm(translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/DeleteConfirmation"))) {
            fetch(this.state.deleteFromLicenseUrl, makeCatalystFetchPostInit({id: this.props.lineItemId, skuToRemove: skuToRemove}))
                .then(resp => resp.json())
                .then(data => {
                    if (!data.hasError) {
                        this.setState({ titles: this.state.titles.filter(title => title.variantCode !== skuToRemove)});
                    } else {
                        window.alert(data.message);
                    }
                })
                .catch((err) => window.alert(err.Message));
            }
    }

    componentDidMount() {
        this.fetchData();
      }
    
      fetchData = async () => {
        try {
          const url = this.props.url + `?lineItemId=${this.props.lineItemId}`
          const response = await fetch(url);
          const jsonData = await response.json();
          this.setState({ titles: jsonData.titles, deleteFromLicenseUrl: jsonData.deleteFromLicenseUrl });
        } catch (error) {
          console.error('Error fetching data for line item: ' + this.props.lineItemId + ':', error);
        }
      };

    render() {
        const titles = this.state.titles.map((title, key) => {
            return (
                <div className='d-flex w-100' key={key}>
                    <div className="title-column col-5">{title.title}</div>
                    <div className="format-column col-7">
                        {title.format}
                        <button title="Delete" className="remove-from-license btn btn-link p-0" onClick={() => this.removeTitleFromLicense(title.variantCode)}>
                            <span className="sr-only">Delete</span><span className="fas fa-align-right fa-times-circle color-red"></span>
                        </button>
                    </div>
                </div>
            );});
        return (
            <div>
                <div className="titles-wrapper">
                    <a href="#" className="titles-link" onClick={() => this.toggleModal(true)}>
                        <span>{translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/LinkText")}</span>
                    </a>
                </div> 
            <Modal id="titlesIncludedInLicense" isOpen={this.state.isOpen}
                toggle={() => this.toggleModal(false)}
                centered={true}
                contentClassName="list-modal"
                role="document" >
                    <ModalHeader>
                        <div className="row">
                            <div className="col-12">
                                <button type="button" className="close" onClick={() => this.toggleModal(false)} aria-label="Close">
                                    <span aria-hidden="true" className="modal-close fas fa-align-right fa-times-circle"></span>
                                </button>
                                <h5 className="headline headline-md">{translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/ModalHeader")}</h5>
                            </div>
                            <div className="col-12">
                                {translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/ModalDescription")}
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="title-table row p-2">
                            <div className="title-column col-5 bg-blue text-white heading">{translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/TitleLabel")}</div>
                            <div className="format-column col-7 bg-blue text-white heading">{translateResourceString("/Checkout/Cart/TitlesIncludedInLicense/FormatLabel")}</div>
                                {titles}
                        </div>
                    </ModalBody>
                </Modal>
            </div>
           
        );
    }
}

TitlesIncludedInLicense.propTypes = {
    lineItemId: PropTypes.isRequired
}

export default TitlesIncludedInLicense;